import { useApiSend } from '../../shared/api/utils/reactQueryProvider';
import { addDriver } from '../api/services/Drivers';

interface iAssignDriverSubmit {
  rideSlug?: string;
  successCallback?: () => void;
  errorCallback?: (error: Error) => void;
}

export const useAssignDriverSubmit = ({ rideSlug, successCallback, errorCallback }: iAssignDriverSubmit) => {
  return useApiSend(
    (payload: { slug: string }) => addDriver(rideSlug, payload),
    successCallback,
    errorCallback,
    ['rideDetails'],
    undefined
  );
};
